<template>
  <div>
    <vx-card>
      <ListSetores :subjectPermission="subjectPermission"></ListSetores>
    </vx-card>
  </div>
</template>

<script>
import ListSetores from "./../../lists/ListSetores";

export default {
  data() {
    return {
      subjectPermission: "Setor",
    };
  },
  methods: {},
  components: {
    ListSetores,
  },
};
</script>
